import React, { useEffect, useState } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { TurnstileLink } from '../../Configs/Links';
import { loadTurnstileApi } from '../../Utils/Captcha/loadTurnstileApi';

const TurnstileDisclaimer = props => {
  const { onReady } = props;

  const [isReady, setIsReady] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    let isCancelled = false;

    const syncTurnstileState = async () => {
      await loadTurnstileApi();

      if (isCancelled) {
        return;
      }

      setIsReady(true);

      if (onReady) {
        onReady(true);
      }
    };

    syncTurnstileState();

    return () => {
      isCancelled = true;
    };
  }, [onReady]);

  if (!isReady) {
    return (
      <Typography className={classes.text}>Cargando Turnstile ...</Typography>
    );
  }

  return (
    <Typography className={classes.text}>
      Este sitio está protegido por Turnstile y aplican las{' '}
      <a
        href={TurnstileLink.Privacy}
        className={classes.link}
        rel="noopener noreferrer"
        target="_blank"
      >
        políticas de privacidad
      </a>{' '}
      y los{' '}
      <a
        href={TurnstileLink.Terms}
        className={classes.link}
        rel="noopener noreferrer"
        target="_blank"
      >
        términos de servicio
      </a>{' '}
      de Cloudflare.
    </Typography>
  );
};

const useStyles = makeStyles(theme => ({
  text: {
    fontSize: 10,
    color: theme.typography.color.light
  },
  link: {
    color: theme.palette.primary.dark
  }
}));

export default TurnstileDisclaimer;
